import { render, staticRenderFns } from "./AddRecordForm.vue?vue&type=template&id=4daf228c"
import script from "./AddRecordForm.vue?vue&type=script&lang=js"
export * from "./AddRecordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports